import { Outlet } from "react-router-dom";
import { Navigation } from "@/components/private/layout/Navigation";
import { Footer } from "@/components/private/layout/Footer";
import Sidebar from "@/components/private/layout/Sidebar";
import { SidebarProvider, useSidebarContext } from "@/components/private/layout/SidebarContext";
import ForceChangePasswordDialog from "@/components/private/ForceChangePasswordDialog";
import ScrollToTop from "@/components/ScrollToTop";
import { cn } from "@/lib/utils";

function LayoutContent() {
    const { isDesktopCollapsed } = useSidebarContext();

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950">
            {/* Scroll otomatis ke atas setiap ganti halaman - sidebar admin cukup panjang jadi tanpa ini,
                posisi scroll ikut sampai ke bawah saat klik menu yang perlu discroll dulu untuk dijangkau. */}
            <ScrollToTop />

            {/* Header */}
            <Navigation />

            {/* Konten utama */}
            <section className="flex-1 py-5 md:py-8">
                <div className="container mx-auto px-4 py-4">
                    <div className={cn(
                        "block lg:grid gap-6 md:gap-8 min-w-0 transition-all duration-300",
                        isDesktopCollapsed ? "lg:grid-cols-1" : "lg:grid-cols-4"
                    )}>
                        {/* Sidebar */}
                        <Sidebar />

                        {/* Konten halaman */}
                        <div className={cn(
                            "transition-all duration-300 min-w-0",
                            isDesktopCollapsed ? "lg:col-span-1" : "lg:col-span-3"
                        )}>
                            <div className="mx-auto py-0 space-y-8">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />

            <ForceChangePasswordDialog />
        </div>
    );
}

export default function Layout() {
    return (
        <SidebarProvider>
            <LayoutContent />
        </SidebarProvider>
    );
}
